import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 *  Calculate zoom step size given number of steps
 *  @param {number} [numSteps=0] - Number of expected zoom levels
 *  @param {number} [maxScale=1] - maximum scale factor to get to actual image resolution
 *  @returns {number} Zoom step size to 2 decimal places
 */

function determineStepSize(numSteps, maxScale) {
  return Math.max(Math.ceil((maxScale - 1) / (numSteps - 1)) * 100 / 100, 1);
}

/**
 *  Calculate image position given window bountaries within a single dimension
 *  @param {number} pos - position relative to center
 *  @param {number} size - width/height
 *  @param {number} stageSize - boundary position
 *  @returns {number} corrected coordinate that falls within
 *  allowed range given provided size and stageSize
 */

function positionWithinRange(pos, size, stageSize) {
  if (size && stageSize) {
    var maxTranslate = stageSize / 2 - size / 2;
    if (size < stageSize) {
      return 0;
    } else if (size > stageSize && pos > 0 && pos >= size / 2 - stageSize / 2) {
      return -maxTranslate;
    } else if (size > stageSize && pos < 0 && pos <= stageSize / 2 - size / 2) {
      return maxTranslate;
    }
  }
  return pos;
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var getClassName = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});


var DEFAULT_HANDLE_MISSING_STYLENAME_OPTION = 'throw';

var isNamespacedStyleName = function isNamespacedStyleName(styleName) {
  return styleName.indexOf('.') !== -1;
};

var getClassNameForNamespacedStyleName = function getClassNameForNamespacedStyleName(styleName, styleModuleImportMap, handleMissingStyleNameOption) {
  // Note:
  // Do not use the desctructing syntax with Babel.
  // Desctructing adds _slicedToArray helper.
  var styleNameParts = styleName.split('.');
  var importName = styleNameParts[0];
  var moduleName = styleNameParts[1];
  var handleMissingStyleName = handleMissingStyleNameOption || DEFAULT_HANDLE_MISSING_STYLENAME_OPTION;

  if (!moduleName) {
    if (handleMissingStyleName === 'throw') {
      throw new Error('Invalid style name: ' + styleName);
    } else if (handleMissingStyleName === 'warn') {
      // eslint-disable-next-line no-console
      console.warn('Invalid style name: ' + styleName);
    } else {
      return null;
    }
  }

  if (!styleModuleImportMap[importName]) {
    if (handleMissingStyleName === 'throw') {
      throw new Error('CSS module import does not exist: ' + importName);
    } else if (handleMissingStyleName === 'warn') {
      // eslint-disable-next-line no-console
      console.warn('CSS module import does not exist: ' + importName);
    } else {
      return null;
    }
  }

  if (!styleModuleImportMap[importName][moduleName]) {
    if (handleMissingStyleName === 'throw') {
      throw new Error('CSS module does not exist: ' + moduleName);
    } else if (handleMissingStyleName === 'warn') {
      // eslint-disable-next-line no-console
      console.warn('CSS module does not exist: ' + moduleName);
    } else {
      return null;
    }
  }

  return styleModuleImportMap[importName][moduleName];
};

exports.default = function (styleNameValue, styleModuleImportMap, options) {
  var styleModuleImportMapKeys = Object.keys(styleModuleImportMap);

  var handleMissingStyleName = options && options.handleMissingStyleName || DEFAULT_HANDLE_MISSING_STYLENAME_OPTION;

  return styleNameValue.split(' ').filter(function (styleName) {
    return styleName;
  }).map(function (styleName) {
    if (isNamespacedStyleName(styleName)) {
      return getClassNameForNamespacedStyleName(styleName, styleModuleImportMap, handleMissingStyleName);
    }

    if (styleModuleImportMapKeys.length === 0) {
      throw new Error('Cannot use styleName attribute for style name \'' + styleName + '\' without importing at least one stylesheet.');
    }

    if (styleModuleImportMapKeys.length > 1) {
      throw new Error('Cannot use anonymous style name \'' + styleName + '\' with more than one stylesheet import.');
    }

    var styleModuleMap = styleModuleImportMap[styleModuleImportMapKeys[0]];

    if (!styleModuleMap[styleName]) {
      if (handleMissingStyleName === 'throw') {
        throw new Error('Could not resolve the styleName \'' + styleName + '\'.');
      }
      if (handleMissingStyleName === 'warn') {
        // eslint-disable-next-line no-console
        console.warn('Could not resolve the styleName \'' + styleName + '\'.');
      }
    }

    return styleModuleMap[styleName];
  }).filter(function (className) {
    // Remove any styles which could not be found (if handleMissingStyleName === 'ignore')
    return className;
  }).join(' ');
};


});

var _getClassName = unwrapExports(getClassName);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".loader__loader-container___2FxLY{\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 0.7em;\n  position: fixed;\n  /* z-index: 99998; */\n  z-index: 2;\n}\n\n.loader__loader___1N0Z6{\n  padding:0;\n  background-color: rgba(0, 0, 0, 0.2);\n  margin: 0;\n  width: 4em;\n  height: 4em;\n  overflow: hidden;\n  position: relative;\n}\n\n.loader__box___n_j27, .loader__box___n_j27:after, .loader__box___n_j27:before{\n  width: 2em;\n  height: 2em;\n  background-color: transparent;\n  margin-top: -2em;\n  animation-name: loader__load___26E_-, loader__cycle___RXGT9;\n  animation-duration: 0.5s, 3.6s;\n  animation-timing-function: cubic-bezier(0.4, 0.0, 0.2, 1);\n  animation-iteration-count: 1, infinite;\n  border-radius: 20%;\n}\n\n.loader__box___n_j27:before, .loader__box___n_j27:after{\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n}\n\n.loader__box___n_j27:before{\n  animation-delay: 1.2s;\n}\n\n.loader__box___n_j27:after{\n  animation-delay: 2.4s;\n}\n\n@keyframes loader__load___26E_-{\n  from{\n    opacity: 0;\n  }\n  to{\n    opacity: 1;\n  }\n}\n\n@keyframes loader__cycle___RXGT9{\n  0%, 15%{\n    box-shadow: 0em 2em 0 -0.5em #FFF;\n    width: 2em;\n    height: 2em;\n  }\n  20%{\n    width: 3em;\n  }\n  25%, 40% {\n    box-shadow: 2em 2em 0 -0.5em #FFF;\n    width: 2em;\n    height: 2em;\n  }\n  45%{\n    height: 3em;\n  }\n  50%, 65% {\n    box-shadow: 2em 4em 0 -0.5em #FFF;\n    width: 2em;\n    height: 2em;\n  }\n  70%{\n    width: 2em;\n  }\n  75%, 90% {\n    box-shadow: 0em 4em 0 -0.5em #FFF;\n    width: 2em;\n    height: 2em;\n  }\n  95%{\n    height: 3em;\n  }\n  100% {\n    box-shadow: 0em 2em 0 -0.5em #FFF;\n    width: 2em;\n    height: 2em;\n  }\n}\n";
styleInject(css);

var _styleModuleImportMap = {
  'loader': {
    'loader-container': 'loader__loader-container___2FxLY',
    'loader': 'loader__loader___1N0Z6',
    'box': 'loader__box___n_j27',
    'load': 'loader__load___26E_-',
    'cycle': 'loader__cycle___RXGT9'
  }
};

var Loader = function Loader() {
  return React.createElement(
    'div',
    {
      className: _getClassName('loader.loader-container', _styleModuleImportMap)
    },
    React.createElement(
      'div',
      {
        className: _getClassName('loader.loader', _styleModuleImportMap)
      },
      React.createElement('div', {
        className: _getClassName('loader.box', _styleModuleImportMap)
      })
    )
  );
};

var css$1 = ".actionIcons__toolbar___Y8wW_ {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position:absolute;\n  top: 0;\n  z-index: 3;\n}\n\n.actionIcons__toolbar___Y8wW_:before{\n  content: \"\";\n  display: block;\n  flex: 1 1 0;\n}\n\n.actionIcons__toolbar___Y8wW_ .actionIcons__justifyCenter___2q41T{\n  flex: 1 1 0;\n  display: flex;\n  justify-content: center;\n}\n\n.actionIcons__toolbar___Y8wW_ .actionIcons__justifyRight___ajKC5{\n  flex: 1 1 0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.actionIcons__iconContainer___1oOde {\n  background-color: rgba(0, 0, 0, 0.6);\n  width: 2.5em;\n  height: 2.5em;\n  opacity: 0.7;\n  margin: 0.5em;\n  box-shadow: 0 0 0 0 transparent;\n}\n\n.actionIcons__iconContainer___1oOde.actionIcons__disabled___1quSB {\n  opacity: 0.2;\n}\n\n.actionIcons__icon___1vU0N {\n  transform: scale(0.5) rotate(0);\n  transform-origin: center;\n  fill: #FFF;\n}\n\n.actionIcons__iconContainer___1oOde:not(.actionIcons__disabled___1quSB):hover {\n  opacity: 1;\n  transition: opacity 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);\n  box-shadow: 0 2px 5px 1px #0006;\n}\n\n.actionIcons__iconContainer___1oOde:not(.actionIcons__disabled___1quSB):hover .actionIcons__icon___1vU0N {\n  transform: scale(0.7) rotate(180deg);\n  transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);\n}\n\n";
styleInject(css$1);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _styleModuleImportMap$1 = {
  'actionIcons': {
    'toolbar': 'actionIcons__toolbar___Y8wW_',
    'justifyCenter': 'actionIcons__justifyCenter___2q41T',
    'justifyRight': 'actionIcons__justifyRight___ajKC5',
    'iconContainer': 'actionIcons__iconContainer___1oOde',
    'disabled': 'actionIcons__disabled___1quSB',
    'icon': 'actionIcons__icon___1vU0N'
  }
};
var CloseIcon = function CloseIcon(props) {
  return React.createElement(
    'div',
    {
      onClick: props.onClick
    },
    React.createElement(
      'svg',
      { viewBox: '0 0 64 64', className: _getClassName('actionIcons.iconContainer', _styleModuleImportMap$1)
      },
      React.createElement(
        'g',
        {
          className: _getClassName('actionIcons.icon', _styleModuleImportMap$1)
        },
        React.createElement(
          'g',
          { transform: 'rotate(45 32 32)' },
          React.createElement('rect', { width: '3em', height: '16', x: '8', y: '24', rx: '7%', ry: '7%' }),
          React.createElement('rect', { width: '3em', height: '16', x: '8', y: '24', rx: '7%', ry: '7%', transform: 'rotate(90 32 32)' })
        )
      )
    )
  );
};

CloseIcon.propTypes = {
  onClick: PropTypes.func.isRequired
};

var MagnifyIcon = function MagnifyIcon(props) {
  return React.createElement(
    'div',
    {
      onClick: props.disabled ? function () {} : props.onClick
    },
    React.createElement(
      'svg',
      {
        viewBox: '0 0 64 64',
        className: _getClassName(classnames('actionIcons.iconContainer', _defineProperty({}, 'actionIcons.disabled', props.disabled)), _styleModuleImportMap$1)
      },
      React.createElement(
        'g',
        {
          className: _getClassName('actionIcons.icon', _styleModuleImportMap$1)
        },
        React.createElement(
          'g',
          null,
          React.createElement('rect', { width: '3em', height: '16', x: '8', y: '24', rx: '7%', ry: '7%' }),
          React.createElement('rect', { width: '3em', height: '16', x: '8', y: '24', rx: '7%', ry: '7%', transform: 'rotate(90 32 32)' })
        )
      )
    )
  );
};

MagnifyIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

var DemagnifyIcon = function DemagnifyIcon(props) {
  return React.createElement(
    'div',
    {
      onClick: props.onClick
    },
    React.createElement(
      'svg',
      {
        viewBox: '0 0 64 64',
        className: _getClassName(classnames('actionIcons.iconContainer', _defineProperty({}, 'actionIcons.disabled', props.disabled)), _styleModuleImportMap$1)
      },
      React.createElement(
        'g',
        {
          className: _getClassName('actionIcons.icon', _styleModuleImportMap$1)
        },
        React.createElement(
          'g',
          null,
          React.createElement('rect', { width: '3em', height: '16', x: '8', y: '24', rx: '7%', ry: '7%' })
        )
      )
    )
  );
};

DemagnifyIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired
};

var _styleModuleImportMap$2 = {
  'actionIcons': {
    'toolbar': 'actionIcons__toolbar___Y8wW_',
    'justifyCenter': 'actionIcons__justifyCenter___2q41T',
    'justifyRight': 'actionIcons__justifyRight___ajKC5',
    'iconContainer': 'actionIcons__iconContainer___1oOde',
    'disabled': 'actionIcons__disabled___1quSB',
    'icon': 'actionIcons__icon___1vU0N'
  }
};
var Toolbar = function Toolbar(props) {
  return React.createElement(
    'div',
    {
      className: _getClassName('actionIcons.toolbar', _styleModuleImportMap$2)
    },
    React.createElement(
      'div',
      {
        className: _getClassName('actionIcons.justifyCenter', _styleModuleImportMap$2)
      },
      React.createElement(DemagnifyIcon, {
        onClick: props.zoomOut,
        disabled: props.zoomOutDisabled
      }),
      React.createElement(MagnifyIcon, {
        onClick: props.zoomIn,
        disabled: props.zoomInDisabled
      })
    ),
    React.createElement(
      'div',
      {
        className: _getClassName('actionIcons.justifyRight', _styleModuleImportMap$2)
      },
      React.createElement(CloseIcon, { onClick: props.closeModal })
    )
  );
};

Toolbar.propTypes = {
  zoomOut: PropTypes.func.isRequired,
  zoomIn: PropTypes.func.isRequired,
  zoomOutDisabled: PropTypes.bool.isRequired,
  zoomInDisabled: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
};

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles$1 = {
  container: {
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.8)',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 99997,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  imageContainer: {},
  img: {
    maxHeight: '100vh',
    maxWidth: '100vw',
    userSelect: 'none'
  }
};

var ImageCloseup = function (_Component) {
  _inherits(ImageCloseup, _Component);

  function ImageCloseup(props) {
    _classCallCheck(this, ImageCloseup);

    var _this = _possibleConstructorReturn(this, (ImageCloseup.__proto__ || Object.getPrototypeOf(ImageCloseup)).call(this, props));

    _this.state = {
      imageLoaded: false,
      dragging: false,
      translateX: 0,
      translateY: 0,
      dragStartX: 0,
      dragStartY: 0,
      dragEndX: 0,
      dragEndY: 0,
      scaleStepSize: 1,
      scale: 1,
      maxScale: 1
    };
    _this.onDrag = _this.onDrag.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDragEnd = _this.onDragEnd.bind(_this);
    _this.handleImageLoad = _this.handleImageLoad.bind(_this);
    _this.zoomIn = _this.zoomIn.bind(_this);
    _this.zoomOut = _this.zoomOut.bind(_this);
    _this.onResizeWindow = _this.onResizeWindow.bind(_this);
    return _this;
  }

  _createClass(ImageCloseup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Once modal is open, prevent background from scrolling
      document.body.style.overflow = 'hidden';
      // prevent dragging behaviour
      window.ondragstart = function () {
        return false;
      };
      window.addEventListener('resize', this.onResizeWindow);
      // Inject css
      // if (!document.querySelector('style#react-image-closeup')) {
      //   const tag = document.createElement('style');
      //   tag.id = 'react-image-closeup';
      //   tag.innerHTML = cssStyles;
      //   document.getElementsByTagName('head')[0].appendChild(tag);
      // }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.style.overflow = 'auto';
      window.removeEventListener('resize', this.onResizeWindow);
    }
  }, {
    key: 'onDrag',
    value: function onDrag(e) {
      if (this.state.dragging) {
        this.setState({
          translateX: this.state.dragEndX + e.pageX - this.state.dragStartX,
          translateY: this.state.dragEndY + e.pageY - this.state.dragStartY
        });
      }
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(e) {
      this.setState({
        dragging: true,
        dragStartX: e.pageX,
        dragStartY: e.pageY
      });
    }
  }, {
    key: 'onDragEnd',
    value: function onDragEnd() {
      var _container$getBoundin = this.container.getBoundingClientRect(),
          width = _container$getBoundin.width,
          height = _container$getBoundin.height;

      var _state = this.state,
          translateX = _state.translateX,
          translateY = _state.translateY;
      var _modal = this.modal,
          stageWidth = _modal.offsetWidth,
          stageHeight = _modal.offsetHeight;

      this.setState({
        dragging: false,
        dragEndX: positionWithinRange(translateX, width, stageWidth),
        dragEndY: positionWithinRange(translateY, height, stageHeight),
        translateX: positionWithinRange(translateX, width, stageWidth),
        translateY: positionWithinRange(translateY, height, stageHeight)
      });
    }
  }, {
    key: 'onResizeWindow',
    value: function onResizeWindow() {
      var _image = this.image,
          actualHeight = _image.naturalHeight,
          scaledHeight = _image.height;

      var _container$getBoundin2 = this.container.getBoundingClientRect(),
          width = _container$getBoundin2.width,
          height = _container$getBoundin2.height;

      var _state2 = this.state,
          translateX = _state2.translateX,
          translateY = _state2.translateY;


      var maxScale = actualHeight / scaledHeight;
      var newScale = this.state.scale / this.state.maxScale * maxScale;
      var scaleStepSize = determineStepSize(this.props.maxZoomLevels, maxScale);
      var _modal2 = this.modal,
          stageWidth = _modal2.offsetWidth,
          stageHeight = _modal2.offsetHeight;

      this.setState({
        scaleStepSize: scaleStepSize,
        maxScale: maxScale,
        scale: newScale,
        dragging: false,
        dragEndX: positionWithinRange(translateX, width, stageWidth),
        dragEndY: positionWithinRange(translateY, height, stageHeight),
        translateX: positionWithinRange(translateX, width, stageWidth),
        translateY: positionWithinRange(translateY, height, stageHeight)
      });
    }
  }, {
    key: 'zoomIn',
    value: function zoomIn() {
      if (this.state.scale < this.state.maxScale) {
        this.setState({
          scale: Math.min(this.state.scale + this.state.scaleStepSize, this.state.maxScale)
        });
      }
    }
  }, {
    key: 'zoomOut',
    value: function zoomOut() {
      if (this.state.scale > 0) {
        this.setState({
          scale: Math.max(this.state.scale - this.state.scaleStepSize, 1)
        });
      }
    }
  }, {
    key: 'handleImageLoad',
    value: function handleImageLoad() {
      var _image2 = this.image,
          actualHeight = _image2.naturalHeight,
          scaledHeight = _image2.height;


      var maxScale = actualHeight / scaledHeight;
      var scaleStepSize = determineStepSize(this.props.maxZoomLevels, maxScale);
      this.setState({
        imageLoaded: true,
        scaleStepSize: scaleStepSize,
        maxScale: maxScale,
        scale: 1
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { ref: function ref(elem) {
            _this2.modal = elem;
          }, style: styles$1.container },
        React.createElement(Toolbar, {
          zoomOut: this.zoomOut,
          zoomIn: this.zoomIn,
          closeModal: this.props.closeModalFunc,
          zoomOutDisabled: !this.state.imageLoaded || this.state.scale <= 1,
          zoomInDisabled: !this.state.imageLoaded || this.state.scale >= this.state.maxScale
        }),
        this.state.imageLoaded ? null : React.createElement(Loader, null),
        React.createElement(
          'div',
          {
            role: 'presentation',
            onMouseMove: this.onDrag,
            onMouseDown: this.onDragStart,
            onMouseUp: this.onDragEnd,
            onMouseLeave: this.onDragEnd,
            ref: function ref(elem) {
              _this2.container = elem;
            },
            style: _extends({}, styles$1.imageContainer, {
              transform: 'translate(' + this.state.translateX + 'px, ' + this.state.translateY + 'px) scale(' + this.state.scale + ')'
            })
          },
          React.createElement('img', {
            src: this.props.imageSrc,
            onLoad: this.handleImageLoad,
            alt: this.props.imageAltText,
            ref: function ref(elem) {
              _this2.image = elem;
            },
            style: styles$1.img
          })
        )
      );
    }
  }]);

  return ImageCloseup;
}(Component);

ImageCloseup.defaultProps = {
  imageAltText: 'full-size-image',
  maxZoomLevels: 5
};

ImageCloseup.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  closeModalFunc: PropTypes.func.isRequired,
  imageAltText: PropTypes.string,
  maxZoomLevels: PropTypes.number
};

export default ImageCloseup;
